module.exports = __webpack_public_path__ + "static/media/tablet-rugged.7c3a02e2.svg";